// Real, human support resources for Israel.
//
// This app is a self-tracking tool, not a treatment provider. For anyone
// dealing with an actual dependency - especially alcohol or benzodiazepines,
// where stopping suddenly can be medically dangerous - a self-tracking app
// should always point toward real professional and peer support, not stand
// in for it.
//
// Numbers checked as of this writing. If any of these have changed, the
// linked sites are the source of truth.
export const SUPPORT_RESOURCES = [
  {
    id: 'eran',
    name: 'ער"ן - עזרה ראשונה נפשית',
    desc: 'קו חירום נפשי ארצי, אנונימי וללא תשלום. לכל מצוקה, בכל שעה.',
    phone: '1201',
    hours: '24/7',
    url: 'https://www.eran.org.il',
  },
  {
    id: 'alsam',
    name: 'אל-סם',
    desc: 'ייעוץ וטיפול בנושא סמים - לנוער, הורים ומבוגרים.',
    phone: '1-700-505-055',
    hours: '24/7 (קו ראשוני)',
    url: 'http://www.alsam.org.il',
  },
  {
    id: 'retorno',
    name: 'רטורנו',
    desc: 'קו ייעודי לתמיכה בנפגעי התמכרויות ובני משפחותיהם.',
    phone: '073-2221115',
    hours: '10:00–22:00, כל יום',
    url: 'https://www.retorno.org',
  },
  {
    id: 'na',
    name: 'מכורים אנונימיים (NA)',
    desc: 'תמיכת עמיתים ל-12 הצעדים, למכורים לסמים. פגישות בעשרות ישובים.',
    phone: '03-3747474',
    hours: '24/7 (קו מידע)',
    url: 'https://www.naisrael.org.il',
  },
  {
    id: 'aa',
    name: 'אלכוהוליסטים אנונימיים (AA)',
    desc: 'תמיכת עמיתים ל-12 הצעדים, למי שרוצה להפסיק לשתות.',
    phone: null,
    hours: 'המספר העדכני מתפרסם באתר',
    url: 'https://www.aa-israel.co.il',
  },
];

// Genuine medical emergency (e.g. severe alcohol or benzodiazepine
// withdrawal - shaking, seizures, confusion) - not a hotline situation.
export const EMERGENCY = {
  name: 'מגן דוד אדום - חירום רפואי',
  phone: '101',
};
